// extracted by mini-css-extract-plugin
export default {"container":"Dashboard_container__pELXh","Spacer":"Dashboard_Spacer__J7ukv","scoreCards":"Dashboard_scoreCards__Wysjo"};